/**
 * This function generates the API content for an error site.
 *
 * @param {Object} props
 * @param {import("react-intl").IntlShape} props.intl - The react-intl object used for formatting localized messages.
 * @param {import("~/config/useGetRichtTextValues").RichTextValues} props.richTextValues
 * @returns {LandingSiteApiProps} - The structured API content for the error landing site.
 */
export const getErrorSiteApiContent = ({ intl }) => ({
  type: 'LANDING_SITE',
  ctaLink: {
    url: intl.formatMessage({
      id: 'errorpage.headerCtaUrl',
    }),
    text: intl.formatMessage({
      id: 'errorpage.headerCtaText',
    }),
    target: 'NEW',
  },
  logoLink: {
    url: '/',
    text: 'Logo link',
    target: 'SELF',
  },
  primaryLinks: [],
  secondaryLinks: [
    {
      url: intl.formatMessage({
        id: 'errorpage.footerDataPrivacyUrl',
      }),
      text: intl.formatMessage({
        id: 'errorpage.footerDataPrivacyText',
      }),
      target: 'NEW',
    },
    {
      url: intl.formatMessage({
        id: 'errorPage.footerLegalUrl',
      }),
      text: intl.formatMessage({
        id: 'errorPage.footerLegalText',
      }),
      target: 'NEW',
    },
    {
      url: intl.formatMessage({
        id: 'errorPage.footerImprintUrl',
      }),
      text: intl.formatMessage({
        id: 'errorPage.footerImprintText',
      }),
      target: 'NEW',
    },
  ],
  openGraph: {
    siteName: '',
  },
});
